import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";

export class CycleComponent extends AlpineComponent {
    private interval: number | null = null;
    private currentIndex: number = 0;
    private timerId: number | null = null;

    public items: Array<string> = [];
    public currentItem: string | null = null;
    constructor(items: string[], interval:number ) {
        super();
        this.items = items;
        this.interval = interval;
    }

    init(): void {
        if (!this.interval || !this.items || this.items.length === 0) {
            return;
        }
        this.currentIndex = 0;
        this.currentItem = this.items[this.currentIndex];
        this.startInterval();
    }

    private startInterval(): void {
        this.clearInterval();
        if (this.interval && this.items.length > 1) {
            this.timerId = window.setInterval(() => {
                this.cycle();
            }, this.interval);
        }
    }

    private clearInterval(): void {
        if (this.timerId !== null) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }

    cycle(item: string | null = null): void {
        if (item !== null) {
            const idx = this.items.indexOf(item);
            if (idx !== -1) {
                this.currentIndex = idx;
                this.currentItem = this.items[this.currentIndex];
                this.startInterval();
                return;
            }
        }
        // Cycle to next item
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        this.currentItem = this.items[this.currentIndex];
        this.startInterval();
    }

    public pause(): void {
        this.clearInterval();
    }

    public resume(): void {
        if (!this.interval || !this.items || this.items.length === 0) {
            return;
        }
        this.startInterval();
    }
}